import {
  GenericElement,
  Pagination,
  TableCellProps,
} from '@agilelab/plugin-wb-platform';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { AsyncState } from 'react-use/lib/useAsyncFn';

export interface AssignmentFormType {
  users?: string[];
  scopes: string[];
}

export enum ScopeEnum {
  system = 'System',
  domain = 'Domain',
  systemType = 'SystemType',
}

export interface CommonFilters {
  search?: string;
}

export interface ProviderFilters extends CommonFilters {
  [key: string]: any;
}

export interface SystemFilters extends ProviderFilters {
  domain?: { name: string; ref: string }[];
  type?: { name: string; ref: string }[];
}

export interface DomainFilters extends ProviderFilters {}

export enum AvailableSystemFilters {
  search = 'search',
  type = 'type',
  domain = 'domain',
}

export interface FilterProps {
  value: { name: string; ref: string }[];
  changeFilters: <K extends keyof SystemFilters>(
    key: K,
    value: SystemFilters[K],
  ) => void;
  getOptions: () => Promise<{ name: string; ref: string }[]>;
}
export interface ScopeProviderType<T, F> {
  columns: TableCellProps<T>[];
  entitiesState: AsyncState<T[]>;
  getRowId: (row: any) => string;
  filters: F;
  changeFilters: <K extends keyof F>(key: K, value: F[K]) => void;
  resetFilters: () => void;
  pagination: Pagination;
  setPagination: Dispatch<SetStateAction<Pagination>>;
  count: number;
  nextCursor?: string;
  prevCursor?: string;
}

export interface MyProvider<T, F> {
  useContext: () => ScopeProviderType<T, F>;
  renderContextProvider: (children: ReactNode) => JSX.Element;
  filtersSection: () => JSX.Element;
  resolve: (ref: string) => Promise<GenericElement | undefined>;
}

export interface SystemFilters extends ProviderFilters {
  domain?: { name: string; ref: string }[];
  type?: { name: string; ref: string }[];
}

export interface TextFieldValue {
  kind: ScopeEnum;
  label: string;
  value?: string | GenericElement;
  kindDisplayName?: string;
}
